import { memo } from "react";

import {
  DESTRUCTIVE_COLOR,
  SECONDARY_COLOR,
} from "@hl/base-components/lib/theme/button";
import { logError } from "@hl/shared-features/lib/services/logger";
import { Button, Divider, Group, Modal, Text } from "@mantine/core";

import { IN_DEVELOPMENT } from "../../../config";
import {
  useDeleteMutation,
  PagesDocument,
} from "../queries/page.graphql.generated";

export interface DeleteModalProps {
  pageId: string;
  opened: boolean;
  onClose: () => void;
}

const DeleteModal = ({ opened, onClose, pageId }: DeleteModalProps) => {
  const [deleteMutation, { loading: isDeleting }] = useDeleteMutation({
    awaitRefetchQueries: true,
    refetchQueries: [PagesDocument],
  });

  const handleDeletePage = async () => {
    try {
      await deleteMutation({
        variables: {
          id: pageId,
        },
      });
      onClose();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      await logError({ error, message: "delete failed" });
      IN_DEVELOPMENT && console.log("🚨 [ERROR][HANDLE_DELETE]: ", error);
    }
  };

  return (
    <Modal size="lg" opened={opened} title="Delete page" onClose={onClose}>
      <Text mt={8}>
        Are you sure you want to delete this page? You can&apos;t undo this
        action.
      </Text>
      <Divider my={16} mx={-16} />
      <Group noWrap>
        <Button fullWidth color={SECONDARY_COLOR} size="xl" onClick={onClose}>
          Cancel
        </Button>
        <Button
          fullWidth
          color={DESTRUCTIVE_COLOR}
          size="xl"
          loading={isDeleting}
          onClick={handleDeletePage}
        >
          Delete page
        </Button>
      </Group>
    </Modal>
  );
};

export default memo(DeleteModal);
